module.exports = __webpack_public_path__ + "img/search.c1989a.svg";